import { IosAvatar } from 'ui/icons/devices/IosAvatar';
import { ChevronRight24 } from 'ui/icons/navigation/ChevronRight24';
import { colors } from 'ui/theme/colors';

import {
  MessageHeaderIos,
  AvatarContainer,
  MessageBody,
  MessageBodyIosDateTime,
  MessageBodyIosMessage,
} from './Wrapper.styled';

export const AppleWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <MessageHeaderIos>
        <ChevronRight24
          style={{ transform: `rotate(180deg)` }}
          color={`#3494FB`}
          height={17}
          width={17}
        />
        <AvatarContainer>
          <IosAvatar color={colors.white} height={34} width={34} />
        </AvatarContainer>
      </MessageHeaderIos>
      <MessageBody>
        <MessageBodyIosDateTime>Text message</MessageBodyIosDateTime>
        <MessageBodyIosDateTime>Today, 2:30</MessageBodyIosDateTime>
        <MessageBodyIosMessage data-test="template-diff-sms-preview-ios-message">
          {children}
        </MessageBodyIosMessage>
      </MessageBody>
    </>
  );
};
